/*
 * Thresholds of the UX laws the library holds (facts model ux_laws, П331–П334; requirement facts 242, П349).
 * A host that builds its own list, target or long action reads them from here instead of repeating the numbers.
 */
/** Hick: a choice of more than this many options gets a search (Select, Menu, Combobox). */
export const HICK = 7;
/** Fitts: every target is at least this many px (an invisible hit area around smaller marks). */
export const FITTS_TARGET = 24;
/** Fitts: the main button of a block is at least this tall. */
export const FITTS_MAIN = 36;
/** Doherty: an action still running after this many ms shows «busy» by itself. */
export const BUSY_AFTER_MS = 400;
/** Hick as a rule: does a list of `count` options need a search? */
export const needsSearch = (count) => count > HICK;
